import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PinPage from '../../../components/PinPage/PinPage';
import { PIN_SECURITY_DESCRIPTION } from '../../../utils/constant';
import { toastNotify } from '../../../utils/toastNotify';
import { applyStoredFirstTouchUtmParams } from '../../../utils/utmTracker';

const CreatePin = () => {
  const [pin, setPin] = useState(undefined);
  let navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('access_token_temp', token);
      searchParams.delete('token');
      const updatedUrl = `${location.pathname}?${searchParams.toString()}`;
      window.history.replaceState(null, '', updatedUrl);
    } else if (!localStorage.getItem('access_token_temp')) {
      navigate('/login', { replace: true });
      return;
    }

    const backendUtmParams = [
      'first_touch_utm_source',
      'first_touch_utm_medium',
      'first_touch_utm_campaign',
      'first_touch_utm_content',
      'first_touch_gclid',
      'first_touch_fbclid',
      'first_touch_gbraid',
    ];
    
    backendUtmParams.forEach(param => {
      const value = searchParams.get(param);
      if (value) {
        localStorage.setItem(param, value);
        searchParams.delete(param);
      }
    });
    
    // Update URL after removing backend UTM parameters
    const cleanedUrl = `${location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, '', cleanedUrl);
    
    // Now add static frontend UTM parameters
    const updatedParams = new URLSearchParams(window.location.search);
    updatedParams.set('utm_source', 'onboarding');
    updatedParams.set('utm_medium', 'web');
    updatedParams.set('utm_content', 'Email_Verified');
    applyStoredFirstTouchUtmParams(updatedParams);

    // Update URL with static frontend UTM parameters
    const finalUrl = `${location.pathname}?${updatedParams.toString()}`;
    window.history.replaceState(null, '', finalUrl);
  }, [location, navigate]);


  const handleCreatePin = () => {
    if (!pin || pin.length < 4) {
      toastNotify('error', 'please fill all the fields');
    } else {
      localStorage.setItem('pin', pin);
      window.location.pathname.includes('reactive-account/createpin') ? navigate('/reactive-account/confirmpin') : navigate('/sign-up/confirmpin');
    }
  };

  return (
    <div className='auth auth--no-info-mobile'>
      <PinPage
        pin={pin}
        authInfoTitle={'Create a PIN to secure your account'}
        authInfoDescription={'Do not share your 4-digit PIN with anyone under any circumstances.'}
        authFormTitle={'Create a new 4-digit PIN'}
        authFormDescription={PIN_SECURITY_DESCRIPTION}
        lockMessage={'All of your information is encrypted and secure.'}
        setPin={(value) => setPin(value)}
        loading={false}
        buttonName={'Save PIN'}
        handleSubmit={handleCreatePin}
      />
    </div>
  );
};

export default CreatePin;
